import type { Dict } from './en.js';

// Português
export const pt: Dict = {
  loading: 'Carregando…',
  back: '← Voltar',
  logOut: 'Sair',
  language: 'Idioma',

  home_tagline: 'Fotos do evento + desafios. Escaneie um QR para entrar, ou organize sua festa.',
  home_joinEvent: 'Entrar em um evento',
  home_joinPlaceholder: 'Digite o código (ex. WS2X9Z)',
  home_join: 'ENTRAR',
  home_hosting: 'Organizando?',
  home_openConsole: 'ABRIR CONSOLE DO ANFITRIÃO →',
  how_eyebrow: 'Como funciona',
  how_scan_label: 'Escaneie',
  how_scan_desc: 'Aponte a câmera para o QR da festa',
  how_shoot_label: 'Fotografe',
  how_shoot_desc: 'Adicione suas melhores fotos à galeria',
  how_vote_label: 'Vote',
  how_vote_desc: 'Coroe os vencedores de cada desafio',

  growth_pitch: 'Quer desafios assim na sua festa?',
  growth_cta: 'Crie a sua →',
  support_contact: 'Suporte',

  // marketing landing (public root "/")
  mkt_nav_cta: 'Crie seu evento',
  mkt_nav_docs: 'Como funciona',
  mkt_hero_eyebrow: 'O jogo de fotos para a sua festa',
  mkt_hero_title: 'Transforme sua festa em um <em>desafio de fotos</em>.',
  mkt_hero_sub:
    'Os convidados escaneiam um QR code, adicionam suas melhores fotos a uma galeria ao vivo e votam em desafios divertidos. Os vencedores são revelados no fim da noite — sem nenhum app para instalar.',
  mkt_hero_ctaPrimary: 'Crie seu evento',
  mkt_hero_ctaSecondary: 'Veja como funciona',
  mkt_hero_trust: 'Sem app para convidados · Funciona em qualquer celular · Pronto em minutos',
  mkt_wall_winner: 'Vencedor',
  mkt_how_eyebrow: 'Como funciona',
  mkt_how_title: 'Três toques. Sem downloads.',
  mkt_feat_eyebrow: 'O que você recebe',
  mkt_feat_title: 'Tudo o que sua festa precisa para jogar.',
  mkt_feat_gallery_title: 'Galeria de fotos ao vivo',
  mkt_feat_gallery_desc: 'As fotos de todos os convidados chegam a um mesmo mural em tempo real.',
  mkt_feat_challenges_title: 'Desafios de fotos e votação',
  mkt_feat_challenges_desc: 'Mais bem vestido, melhor passo de dança, cara mais engraçada — os convidados votam nos vencedores.',
  mkt_feat_reveal_title: 'Revelação dos vencedores',
  mkt_feat_reveal_desc: 'Coroe cada desafio com uma chuva de confete quando a festa termina.',
  mkt_feat_qr_title: 'Entram com um QR',
  mkt_feat_qr_desc: 'Os convidados escaneiam e já estão dentro. Nada para baixar, funciona em qualquer celular.',
  mkt_feat_branding_title: 'Deixe do seu jeito',
  mkt_feat_branding_desc: 'Adicione seu próprio pôster e fundo para dar a cara do seu evento.',
  mkt_feat_keep_title: 'Guarde cada foto',
  mkt_feat_keep_desc: 'Baixe a galeria inteira depois da festa. Armazenamento opcional por 1 ano.',
  mkt_shots_eyebrow: 'Veja ao vivo',
  mkt_shots_title: 'Direto de uma festa real.',
  mkt_shots_gallery: 'A galeria ao vivo',
  mkt_shots_voting: 'Vote nos desafios',
  mkt_shots_wall: 'O mural dos vencedores',
  mkt_price_eyebrow: 'Preço simples',
  mkt_price_title: 'Pague uma vez por evento. Sem assinatura.',
  mkt_price_upto: 'Até {count} convidados',
  mkt_price_incl1: 'Todo convidado entra grátis, sem instalar apps',
  mkt_price_incl2: 'Galeria ao vivo + desafios de fotos',
  mkt_price_incl3: 'Revelação dos vencedores + fotos para baixar',
  mkt_price_note: 'Sem anúncios. Nunca vendemos suas fotos. Você só paga quando publica seu evento.',
  mkt_price_cta: 'Crie seu evento',
  mkt_final_title: 'Pronto para agitar sua festa?',
  mkt_final_sub: 'Monte seu evento em alguns minutos e compartilhe um único QR code com seus convidados.',
  mkt_final_cta: 'Crie seu evento',
  mkt_footer_join: 'Entrar em um evento',

  auth_login: 'Entrar',
  auth_createAccount: 'Criar conta de {type}',
  auth_host: 'anfitrião',
  auth_participant: 'participante',
  auth_emailOrUsername: 'E-mail ou usuário',
  auth_email: 'E-mail',
  auth_username: 'Usuário',
  auth_password: 'Senha',
  auth_passwordHint: 'No mínimo {min} caracteres.',
  auth_usernameHint: 'Usuário: apenas letras, números e . _ - — sem espaços, {min}–{max} caracteres.',
  auth_emailInvalid: 'Informe um e-mail válido.',
  auth_logInBtn: 'ENTRAR',
  auth_signUp: 'CADASTRAR',
  auth_needAccount: 'Não tem conta? Cadastre-se',
  auth_haveAccount: 'Já tem conta? Entre',
  auth_genericError: 'Algo deu errado',
  auth_forgotPassword: 'Esqueceu sua senha?',
  forgot_title: 'Recuperar senha',
  forgot_subtitle: 'Informe o email da sua conta e enviaremos um link para redefinir sua senha.',
  forgot_send: 'ENVIAR LINK',
  forgot_sent: 'Se existir uma conta com esse email, o link já está a caminho. Verifique sua caixa de entrada (e o spam).',
  forgot_backToLogin: 'Voltar ao login',
  reset_title: 'Redefinir senha',
  reset_subtitle: 'Escolha uma nova senha para sua conta.',
  reset_newPassword: 'Nova senha',
  reset_confirmPassword: 'Confirmar nova senha',
  reset_submit: 'SALVAR SENHA',
  reset_mismatch: 'As senhas não coincidem.',
  reset_done: 'Senha atualizada. Levando você ao login…',
  reset_noToken: 'Este link de redefinição é inválido ou está incompleto. Solicite um novo.',

  join_subtitle: 'Fotografe com sua câmera → vote nos vencedores. Sem instalar nada.',
  join_pinPlaceholder: 'PIN de acesso (se necessário)',
  join_consent: 'Concordo que minhas fotos podem aparecer na galeria compartilhada e como candidatas nos desafios.',
  join_joinAsGuest: 'ENTRAR COMO CONVIDADO E ADICIONAR FOTOS',
  join_joinAndAdd: 'ENTRAR E ADICIONAR FOTOS',
  join_joining: 'ENTRANDO…',
  join_joiningAs: 'Entrando como {name}',
  join_notYou: 'não é você?',
  join_optionalAccount: '+ Entre / cadastre-se para receber resultados por e-mail (opcional)',
  join_couldNotJoin: 'Não foi possível entrar',

  uploader_addPhotos: 'Adicionar fotos',
  uploader_left: '{n} RESTANTES',
  uploader_open: 'ABRIR CÂMERA / ESCOLHER FOTOS',
  uploader_none: 'SEM ENVIOS DISPONÍVEIS',
  uploader_notStarted: 'A festa ainda não começou',
  uploader_opensAt: 'O envio de fotos abre em {time}',
  uploader_capReached: 'Limite de envios atingido',
  uploader_failed: 'Falha no envio',

  gallery_live: 'Galeria ao vivo',
  gallery_empty: 'Ainda não há fotos — seja o primeiro.',
  gallery_locked: 'As fotos são liberadas quando o anfitrião as revela.',
  gallery_loadMore: 'CARREGAR MAIS',
  share_photo: 'Compartilhar foto',
  share_copied: 'Texto copiado para a área de transferência',
  share_failed: 'Não foi possível compartilhar — tente novamente',
  share_legend: 'Anime seus eventos com o <a>Fiesta Challenges</a>!',
  share_invite: 'Entre em {name} no Fiesta! Tire fotos da festa e vote nos desafios:',
  hostEvent_shareInvite: 'COMPARTILHAR CONVITE',
  join_inviteFriends: 'Convidar amigos',

  polls_title: 'Desafios',
  polls_open: 'ABERTO',
  polls_voted: 'VOTADO ✓',
  polls_closed: 'FECHADO',
  polls_vote: 'VOTAR',
  polls_voting: 'VOTANDO…',
  polls_yourVote: 'seu voto',
  polls_photo: 'Foto',
  polls_votesFinal: '{n} votos · final',
  polls_votesLive: '{n} votos · ao vivo',
  polls_couldNotVote: 'Não foi possível votar',
  polls_submitPhoto: 'Envie sua foto',
  polls_submitHint: 'Participe deste desafio com sua própria foto:',
  polls_submitting: 'Enviando…',
  polls_noSubmissions: 'Ainda sem envios — seja o primeiro!',
  polls_closesIn: 'A votação encerra em',
  polls_votingClosed: 'Votação encerrada — a festa acabou',

  results_title: 'RESULTADOS',
  results_loginPrompt: 'Entre para ver os resultados deste evento.',
  results_loggingIn: 'ENTRANDO…',
  results_noAccess: 'Essa conta não tem acesso a estes resultados.',
  results_expired: 'As fotos e os resultados deste evento expiraram e não estão mais disponíveis.',
  results_noPollsClosed: 'Nenhum desafio foi fechado ainda.',
  results_gallery: 'O mural',
  results_openPhoto: 'Ver foto',
  results_votes: '{n} votos',
  results_winner: 'Vencedor',
  results_runnersUp: 'Finalistas',
  results_noVotesYet: 'Ainda sem votos',
  results_couldNotLoad: 'Não foi possível carregar os resultados',
  results_opening: 'Abrindo resultados…',
  results_openAtLink: 'Abra o evento para ver os resultados',

  host_title: 'Console do anfitrião',
  host_signedInAs: 'Conectado como {name}',
  host_loginPrompt: 'Entre ou crie uma conta de anfitrião para gerenciar eventos.',
  host_participantWarning: 'Você está conectado como participante ({name}). Ações de anfitrião exigem uma conta de anfitrião.',
  host_createEvent: '+ CRIAR EVENTO',
  host_myEvents: 'Meus eventos',
  host_noEvents: 'Nenhum evento ainda.',

  create_title: 'Criar evento',
  create_name: 'Nome do evento',
  create_starts: 'Início',
  create_ends: 'Término',
  create_capacity: 'Capacidade (convidados)',
  create_guestsUpTo: 'Até {count} convidados',
  create_revealMode: 'Modo de revelação',
  create_revealLive: 'Ao vivo (as fotos aparecem durante a festa)',
  create_revealAfter: 'Revelar depois',
  create_submit: 'CRIAR E PUBLICAR',
  create_creating: 'CRIANDO…',
  create_couldNotCreate: 'Não foi possível criar o evento',

  hostEvent_backToEvents: '← Meus eventos',
  hostEvent_editName: 'Editar título',
  hostEvent_editDate: 'Editar data',
  hostEvent_save: 'Salvar',
  hostEvent_cancel: 'Cancelar',
  hostEvent_posterPosition: 'Reposicionar',
  hostEvent_draftNote: 'Este evento é um rascunho — publique para compartilhar.',
  hostEvent_publish: 'PUBLICAR (teste)',
  hostEvent_publishFailed: 'Falha ao publicar (o TEST_MODE está ativo?)',
  hostEvent_scanToJoin: 'Escaneie para entrar e começar a jogar os desafios!',
  hostEvent_copyLink: 'COPIAR LINK',
  hostEvent_copied: 'COPIADO ✓',
  hostEvent_viewResults: 'VER PÁGINA DE RESULTADOS →',
  hostEvent_liveResults: 'Resultados ao vivo',
  hostEvent_newPoll: 'Novo desafio (as candidatas são carregadas ao abrir)',
  hostEvent_pollTitlePlaceholder: 'Título do desafio',
  hostEvent_votePhotos: 'Votar em fotos',
  hostEvent_votePeople: 'Votar em pessoas',
  hostEvent_voteSubmissions: 'Envio de fotos (convidados enviam)',
  hostEvent_addPoll: 'ADICIONAR DESAFIO',
  hostEvent_open: 'Abrir',
  hostEvent_close: 'Fechar',
  hostEvent_candidates: '{n} candidatas',
  hostEvent_couldNotLoad: 'Não foi possível carregar o evento',
  hostEvent_couldNotCreatePoll: 'Não foi possível criar o desafio',

  admin_title: 'Console de administrador',
  admin_loginPrompt: 'Entre com uma conta de superadministrador.',
  admin_notAdmin: 'Esta conta não é administradora.',
  admin_events: 'Eventos',
  admin_published: 'Publicados',
  admin_participants: 'Participantes',
  admin_polls: 'Desafios',
  admin_votes: 'Votos',
  admin_photos: 'Fotos',
  admin_revenue: 'Receita',
  admin_colEvent: 'Evento',
  admin_colHost: 'Anfitrião',
  admin_colStatus: 'Status',
  admin_colFee: 'Pago recebido',
  admin_couldNotLoad: 'Não foi possível carregar o painel',
  admin_tab_overview: 'Resumo',
  admin_tab_events: 'Eventos',
  admin_tab_polls: 'Desafios',
  admin_tab_users: 'Usuários',
  admin_colTitle: 'Título',
  admin_colVisibility: 'Contagem',
  admin_colCandidates: 'Candidatas',
  admin_colRole: 'Função',
  admin_colType: 'Tipo',
  admin_colEmail: 'E-mail',
  admin_colHosted: 'Organizados',
  admin_colJoined: 'Entrou',
  admin_colVotesCast: 'Votos dados',
  admin_colCreated: 'Criado',
  admin_delete: 'Excluir',
  admin_deleteConfirm: 'Excluir “{name}” e todos os seus dados? Isso não pode ser desfeito.',
  admin_deleting: 'Excluindo…',
  admin_detail_participants: 'Participantes',
  admin_detail_payments: 'Pagamentos',
  admin_detail_hosted: 'Eventos organizados',
  admin_detail_memberships: 'Eventos em que entrou',
  admin_anonymous: 'Anônimo',
  admin_winner: 'vencedor',
  admin_when: 'Quando',
  admin_joinCode: 'Código',
  admin_none: 'Nenhum',
  admin_tab_suggestions: 'Desafios sugeridos',
  admin_tab_emails: 'E-mails',
  admin_detail_emails: 'E-mails',
  admin_colSource: 'Origem',
  admin_colConsent: 'Aceitou',
  admin_colCollected: 'Coletado',
  admin_exportCsv: 'Baixar CSV',
  admin_key: 'Chave',
  admin_source: 'Origem',
  admin_order: 'Ordem',
  admin_active: 'Ativo',
  admin_add: 'Adicionar',
  admin_save: 'Salvar',
  admin_edit: 'Editar',
  admin_cancel: 'Cancelar',
  admin_newSuggestion: 'Novo desafio sugerido',
  admin_yes: 'Sim',
  admin_no: 'Não',
  admin_tab_coupons: 'Cupons',
  admin_newCoupon: 'Novo cupom',
  admin_couponCode: 'Código',
  admin_couponFree: 'Grátis',
  admin_couponPercent: '% de desconto',
  admin_couponPercentOff: '% desc.',
  admin_couponMaxRedemptions: 'Máx. usos (vazio = ∞)',
  admin_couponExpires: 'Expira (vazio = nunca)',
  admin_couponRedeemed: 'usados',

  hostEvent_poster: 'Pôster da festa',
  hostEvent_addPoster: 'Adicionar pôster',
  hostEvent_changePoster: 'Trocar pôster',
  hostEvent_posterUploading: 'Enviando…',
  hostEvent_background: 'Fundo personalizado',
  hostEvent_addBackground: 'Adicionar fundo',
  hostEvent_changeBackground: 'Trocar fundo',
  hostEvent_posterHint: 'Funciona melhor na vertical — cerca de 1080×1350 px (4:5). Mantenha o assunto principal centralizado; as bordas podem ser cortadas. JPG ou PNG, até 12 MB.',
  hostEvent_backgroundHint: 'Fundo de tela cheia do celular — use uma imagem vertical alta, cerca de 1080×1920 px (9:16). Mantenha o essencial centralizado; fica atrás de uma camada escura. JPG ou PNG, até 12 MB.',
  hostEvent_saveDone: 'Salvar e concluir',
  hostEvent_saved: 'Salvo ✓',
  hostEvent_photos: 'Fotos',
  hostEvent_photosHint: 'Todas as fotos da festa, incluindo as dos desafios. Exclua qualquer conteúdo inadequado — ele é removido para todos, inclusive do telão, e não pode ser desfeito.',
  hostEvent_photosEmpty: 'Nenhuma foto enviada ainda.',
  hostEvent_deletePhoto: 'Excluir foto',
  hostEvent_deletePhotoConfirm: 'Excluir esta foto permanentemente? Não pode ser desfeito.',
  hostEvent_deleteChallengePhotoConfirm: 'Excluir esta foto permanentemente? Ela também sai do desafio "{c}" e os votos recebidos são descartados. Não pode ser desfeito.',
  hostEvent_deleteAllPhotos: 'Excluir todas as fotos',
  hostEvent_deleteAllPhotosConfirm: 'Excluir permanentemente todas as {n} fotos? Não pode ser desfeito.',
  hostEvent_previewInvitation: 'Visualizar convite',
  hostEvent_voting: 'Votação',
  hostEvent_votingEnds: 'A votação termina',
  hostEvent_extend1h: 'Estender +1 hora',
  hostEvent_closeVotingNow: 'Encerrar votação agora',
  invite_print: 'Imprimir / Salvar como PDF',
  invite_youreInvited: 'Você está convidado',
  hostEvent_suggestionsHint: 'Escolha um desafio sugerido ou digite o seu',
  hostEvent_suggestionSelect: '— Escolha um desafio sugerido —',

  join_emailOptional: 'E-mail (opcional) — para resultados e novidades',
  join_marketingOptIn: 'Quero receber novidades do evento por e-mail',

  photo_takePhoto: 'Tirar foto',
  photo_chooseLibrary: 'Galeria',

  nav_back: 'Voltar',

  consent_title: 'Só uma coisa',
  consent_agreeJoin: 'Aceitar e entrar',
  consent_cancel: 'Cancelar',

  gallery_loadError: 'Não foi possível carregar as fotos — a conexão caiu.',
  gallery_errorEnded: 'Esta festa terminou — não é possível adicionar novas fotos.',
  gallery_errorNotMember: 'Entre na festa novamente para ver as fotos.',
  gallery_errorGone: 'Esta festa não está mais disponível.',
  gallery_retry: 'Tentar de novo',

  ticker_newPhoto: '📸 Nova foto!',
  ticker_newVote: '🔥 Alguém votou!',
  ticker_newPhotoIn: '📸 Nova foto em {c}!',
  ticker_newVoteIn: '🔥 Novo voto em {c}!',
  wall_general: 'Galeria',
  wall_winnerOf: 'Vencedor de',
  wall_timeLeft: 'Tempo restante',
  wall_votingEndsIn: 'A votação termina em:',
  wall_votingClosed: 'Votação encerrada',
  wall_partyOverTitle: '🏆 Os vencedores',
  wall_partyOver: '🏆 Acabou — estes são os vencedores!',
  wall_wrapTitle: '🎉 Acabou a festa!',
  wall_wrapBody: 'Obrigado por celebrar com a gente. A galeria continua aberta — baixe suas fotos.',

  wall_join: 'Entre na festa em',
  wall_empty: 'Esperando a primeira foto…',
  wall_photos: 'fotos',
  wall_unavailable: 'O mural ao vivo deste evento não está disponível para exibição pública.',
  hostEvent_openWall: '📺 ABRIR MURAL AO VIVO (PROJETOR)',
  hostEvent_wallHint: 'Um mural de fotos ao vivo em tela cheia para exibir numa TV ou projetor — sem login. Funciona durante e depois da festa.',
  hostEvent_copyWallLink: 'Copiar link do mural',

  footer_privacy: 'Política de Privacidade',
  footer_terms: 'Termos de Serviço',
  footer_deleteAccount: 'Excluir conta',
  legal_lastUpdated: 'Última atualização',
  legal_placeholder: 'Este é um modelo inicial — peça revisão jurídica antes do lançamento.',

  // payment / publish
  pay_title: 'Publique seu evento',
  pay_eventFee: 'Taxa do evento',
  pay_storageAddon: '+1 ano de armazenamento de fotos',
  pay_total: 'Total',
  pay_promoLabel: 'Código promocional',
  pay_promoApply: 'Aplicar',
  pay_promoApplied: 'Código aplicado',
  pay_promoFree: 'Evento grátis!',
  pay_promoInvalid: 'Esse código promocional não é válido',
  pay_payAndPublish: 'Pagar {amount} e publicar',
  pay_publishFree: 'Publicar grátis',
  pay_publishTest: 'Publicar (modo teste — sem cobrança)',
  pay_notConfigured: 'Os pagamentos ainda não foram configurados. Tente mais tarde.',
  pay_processing: 'Processando…',
  pay_backToEdit: '← Voltar para editar o evento',

  // published landing
  published_checking_title: 'Confirmando seu pagamento…',
  published_checking_subtitle:
    'Um instante — isso costuma levar apenas alguns segundos. Mostraremos o código de acesso assim que for confirmado.',
  published_pending_title: 'Quase lá — finalizando seu evento',
  published_pending_subtitle:
    'Isso está demorando um pouco mais que o normal. Seu evento será publicado automaticamente assim que o pagamento for confirmado. Você pode verificar novamente ou ir ao seu painel — ele também será atualizado lá.',
  published_checkAgain: 'Verificar novamente',
  published_title: 'Você está no ar! 🎉',
  published_subtitle: 'Seu evento foi publicado. Compartilhe o código com seus convidados.',
  published_joinCode: 'Código de acesso',
  published_manage: 'Gerenciar evento',

  err_generic: 'Algo deu errado. Tente novamente.',
  err_EVENT_NOT_JOINABLE: 'Evento não encontrado ou não está aberto.',
  err_EVENT_NOT_FOUND: 'Evento não encontrado.',
  err_EVENT_ENDED: 'Este evento foi encerrado.',
  err_EVENT_NOT_STARTED: 'A festa ainda não começou — o envio de fotos abre no horário de início.',
  err_EVENT_EXPIRED: 'Este evento expirou.',
  err_NOT_A_MEMBER: 'Entre no evento primeiro.',
  err_NO_ACCESS: 'Você não tem acesso a estes resultados.',
  err_ALREADY_VOTED: 'Você já votou neste desafio.',
  err_POLL_CLOSED: 'Este desafio está fechado.',
  err_POLL_NOT_OPEN: 'Este desafio ainda não está aberto.',
  err_POLL_NOT_FOUND: 'Desafio não encontrado.',
  err_BAD_CANDIDATE: 'Escolha uma opção válida.',
  err_UPLOAD_CAP_REACHED: 'Você atingiu o limite de envios para este evento.',
  err_BAD_PIN: 'PIN de acesso incorreto.',
  err_AGE_ACK_REQUIRED: 'Você precisa confirmar que tem mais de 18 anos para entrar.',
  err_ACCOUNT_EXISTS: 'Esse e-mail ou usuário já está em uso.',
  err_EMAIL_EXISTS: 'Esse e-mail já está cadastrado. Tente entrar.',
  err_USERNAME_EXISTS: 'Esse usuário já está em uso. Escolha outro.',
  err_INVALID_CREDENTIALS: 'E-mail/usuário ou senha inválidos.',
  err_PASSWORD_BREACHED: 'Esta senha apareceu em um vazamento. Escolha outra.',
  err_NOT_A_HOST: 'Apenas contas de anfitrião podem fazer isso.',
  err_NOT_HOST: 'Apenas o anfitrião pode fazer isso.',
  err_NOT_PAID: 'Pague o evento primeiro.',
  err_ALREADY_PAID: 'Este evento já está pago.',
  err_ALREADY_EXTENDED: 'Este evento já tem armazenamento de 1 ano.',
  err_TEST_DISABLED: 'A publicação de teste está desativada.',
  err_NOT_ADMIN: 'Acesso de administrador necessário.',
  err_RATE_LIMITED: 'Muitas tentativas. Aguarde um momento.',
  err_VALIDATION_ERROR: 'Verifique o formulário e tente novamente.',
  err_UNAUTHORIZED: 'Faça login novamente.',
  err_COUPON_NOT_FOUND: 'Esse código promocional não é válido',
  err_COUPON_INACTIVE: 'Esse código promocional não está mais ativo',
  err_COUPON_EXPIRED: 'Esse código promocional expirou',
  err_COUPON_EXHAUSTED: 'Esse código promocional já foi totalmente resgatado',
  err_COUPON_EXISTS: 'Já existe um cupom com esse código',

  // exclusão de conta (console do anfitrião)
  account_dangerZone: 'Zona de risco',
  account_delete: 'Excluir minha conta',
  account_deleteConfirm:
    'Isto exclui sua conta permanentemente. Os eventos que você já pagou continuam ativos até o vencimento normal do armazenamento. Digite sua senha para confirmar.',
  account_passwordPlaceholder: 'Sua senha',
  account_deleteCta: 'Excluir permanentemente',
  account_deleteCancel: 'Cancelar',
  account_deleting: 'Excluindo…',
  account_deleteError: 'Não foi possível excluir sua conta. Verifique sua senha e tente novamente.',

  // cancelamento de marketing / exclusão de dados
  unsub_title: 'E-mails de marketing',
  unsub_intro: 'Gerencie os e-mails de marketing vinculados ao seu endereço de e-mail.',
  unsub_unsubscribe: 'Cancelar inscrição nos e-mails de marketing',
  unsub_unsubscribed: 'Pronto — você não receberá mais e-mails de marketing nossos.',
  unsub_forget: 'Excluir meus dados',
  unsub_forgetHint: 'Remova seu e-mail da nossa lista de marketing permanentemente.',
  unsub_forgotten: 'Pronto — seu e-mail foi removido da nossa lista de marketing.',
  unsub_missingToken: 'Este link é inválido ou expirou.',
  unsub_error: 'Algo deu errado. Tente novamente.',
  unsub_working: 'Processando…',

  // public account-deletion instructions page (/delete-account)
  del_title: 'Excluir sua conta',
  del_intro:
    'Você pode excluir permanentemente sua conta Fiesta a qualquer momento. A exclusão é imediata e não pode ser desfeita.',
  del_whatTitle: 'O que é removido',
  del_what1: 'Sua conta e seu perfil: e-mail, usuário e acesso.',
  del_what2: 'As fotos que você enviou e quaisquer eventos em rascunho não publicados são apagados permanentemente do armazenamento.',
  del_what3:
    'Os eventos que você já pagou permanecem ativos até o vencimento normal do armazenamento e depois são excluídos automaticamente.',
  del_howTitle: 'Como excluir sua conta',
  del_step1: 'Faça login na sua conta.',
  del_step2: 'Abra o console do anfitrião e encontre “Excluir minha conta” na Zona de perigo.',
  del_step3: 'Digite sua senha para confirmar. Sua conta é excluída imediatamente.',
  del_cta: 'Entrar para excluir',
  del_noLoginTitle: 'Não consegue entrar?',
  del_noLogin: 'Se você não consegue mais acessar sua conta, envie um e-mail e nós a excluiremos para você:',
  del_privacyLink: 'Veja nossa Política de Privacidade sobre como tratamos seus dados.',
};
